import { render } from "./detailCv.vue?vue&type=template&id=5c7597c5&scoped=true&ts=true"
import script from "./detailCv.vue?vue&type=script&lang=ts"
export * from "./detailCv.vue?vue&type=script&lang=ts"

import "./detailCv.vue?vue&type=style&index=0&id=5c7597c5&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/OfferCloud2_FrontWebs_All/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7597c5"]])

export default __exports__